import axios from "axios";
import * as d3 from "d3";
import {
    axisTextDim1,
    colonAnnotation,
    fw_progressive_1way,
    inrFormatter,
    numberFormat,
    responsivefy
} from '../functions'
import {legendColor} from "d3-svg-legend";

export default function (chart, divId, vizName, filterParam) {
    console.log("Chart vizName called:", vizName, divId)

    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName


    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chart.width + chart.margin.left + chart.margin.right)
        .attr("height", chart.height + 2 * chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

    var g = svg.append("g")

    axios.post(url, filterParam).then(res => {
        let data = res.data

        data = data.filter(function (d) {
            return d.dim1_name == d.dim1_name
        })
        var dataXAxis = d3.nest()
            .key(d => {
                return d.dim2_name;
            })
            .key(d => {
                return d.dim1_name;
            })
            .rollup(v => {
                return d3.sum(v, d => {
                    return d.metric1;
                });
            })
            .entries(data);

        dataXAxis.forEach(y => {
            y.year = y.key;
            y.values.forEach(d => {
                d.dim1_name = d.key;
                d.sumTotalCost = +d.value;
            });
            y.values.sort((a, b) => {
                return b.sumTotalCost - a.sumTotalCost;
            });
        });

        var mainCategoryList = dataXAxis[0].values.map(d => {
            return d.dim1_name;
        });
        var yearList = dataXAxis.map(d => {
            return d.year;
        });

        console.log("stacked data", data, dataXAxis, yearList)

        var y1legend = g.append('g').attr('transform', `translate(${chart.width - 50}, 0)`);
        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).paddingInner(0.3);
        var x2Scale = d3.scaleBand().padding(.1);
        var y1Scale = d3.scaleLinear().rangeRound([chart.height, 0]);
        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);

        x1Scale.domain(yearList);
        x2Scale.domain(mainCategoryList).rangeRound([5, x1Scale.bandwidth()]);
        y1Scale.domain([0, d3.max(dataXAxis, d => {
            return d3.max(d.values, el => {
                return el.sumTotalCost;
            });
        })]).nice();
        metric1ColorScale.domain(mainCategoryList);
        // Should there be a class for tooltip?
        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip'+divId.id)
            .html(d => d.dim1_name+ colonAnnotation +  numberFormat(d.sumTotalCost));

        svg.call(y1tip)*/
        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        var year = g.append("g")
            .selectAll("g")
            .data(dataXAxis)
            .enter()
            .append("g")
            .attr("transform", d => {
                return "translate(" + x1Scale(d.year) + ",0)";
            })

        var rect = year.selectAll(".bar")
            .data(d => {
                return d.values;
            })
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("y", chart.height)
            .attr("width", x1Scale.bandwidth())
            .attr("height", 0)
            .attr("fill", d => {
                return metric1ColorScale(d.dim1_name);
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.dim1_name + colonAnnotation + numberFormat(d.sumTotalCost))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })
        //.on('mouseover', y1tip.show)
        //.on('mouseout', y1tip.hide)

        rect.transition()
            .duration(300)
            .attr('class', d => `data-point ${d.dim1_name}`)
            .attr("x", d => {
                return x2Scale(d.dim1_name);
            })
            .attr("y", d => {
                return y1Scale(d.sumTotalCost);
            })
            .attr("width", x2Scale.bandwidth())
            .attr("height", d => {
                return chart.height - y1Scale(d.sumTotalCost)
            })

        svg.append("g")
            .attr("class", "axisL20")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(d3.axisBottom(x1Scale))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            // .attr('dx', '-1em')
            .attr('dy', '-0.05em')
            //.attr('dx', XaxisAttribute)
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim1)

        svg.append("g")
            .attr("class", "axisL20")
            .call(d3.axisLeft(y1Scale).tickFormat(inrFormatter))
            .selectAll('text')
            .style('font-size', axisLabelFontSize);

        svg.append("text")
            .attr("x", (chart.width / 2))
            .attr("y", chart.height + (chart.margin.bottom + 5 * chart.axisLabelDistance))
            .style("fill", fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize);

        svg.append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - chart.margin.left)
            .attr("x", 0 - (chart.height / 2))
            .attr("dy", "1em")
            .style("text-anchor", "middle")
            .style("fill", fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize);

        // color legend
        var selected = '';
        var y2legend = legendColor()
            .scale(metric1ColorScale)
            .shape('rect') //rect to circle for the circle legend
            //                .shapeRadius(5)
            .on('cellclick', function (d) {
                d3.selectAll("rect").style("opacity", 1)
                if (selected !== d) {
                    d3.selectAll("rect")
                        .filter(function (e) {
                            return e !== d.dim1;
                        })
                        .style("opacity", 0)
                    selected = d
                } else {
                    selected = ''
                }
                var legendCell = d3.select(this);
                legendCell.classed('hidden', !legendCell.classed('hidden'));
            })

        y1legend.call(y2legend);

        d3.selectAll("input").on("change", change);
        var timeout = setTimeout(() => {
            d3.select("input[value=\"grouped\"]").property("checked", true).each(change);
        }, 2000);

        function change() {
            clearTimeout(timeout);
            if (this.value === "grouped") transitionGrouped();
            else transitionStacked();
        }

        function transitionGrouped() {
            rect.transition()
                .duration(300)
                .attr("x", d => {
                    return x2Scale(d.dim1);
                })
                .attr("width", x2Scale.bandwidth())
                .transition()
                .attr("y", d => {
                    return y1Scale(d.sumTotalCost);
                })
                .attr("height", d => {
                    return chart.height - y1Scale(d.sumTotalCost);
                });
        }

        function transitionStacked() {
            rect.transition()
                .duration(300)
                .attr("y", d => {
                    return y1Scale(d.sumTotalCost);
                })
                .attr("height", d => {
                    return chart.height - y1Scale(d.sumTotalCost);
                })
                .transition()
                .attr("x", d => {
                    return x1Scale(d.dim1);
                })
                .attr("width", 100);
        }
    });
}
